var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",class:_vm.state.class,attrs:{"depressed":"","small":""}},[_vm._v(" "+_vm._s(_vm.state.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }